import { useEffect, useState } from "react";
import { Loader2, Trash2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-xl bg-black/30 border border-white/5 p-4" data-testid={testid}>
    <div className="text-2xl font-bold text-white font-mono">{value}</div>
    <div className="text-xs text-slate-400 mt-1">{label}</div>
  </div>
);

export const CleanupTab = () => {
  const [d, setD] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/cleanup").then((r) => setD(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/cleanup", { confirm });
      toast.success(`Nettoyage terminé : ${data.workspaces} espaces, ${data.users} comptes, ${data.clips} clips supprimés`);
      setConfirm(""); load();
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  if (!d) return <Loader2 className="w-5 h-5 animate-spin text-slate-400" />;
  return (
    <div className="cx-panel rounded-2xl p-6 space-y-6 max-w-3xl" data-testid="cleanup-tab">
      <div>
        <h3 className="font-display text-lg text-white flex items-center gap-2"><Trash2 className="w-5 h-5 text-[#ff4d6d]" />Nettoyer les données de test</h3>
        <p className="text-sm text-slate-400 mt-1">Réinitialisation avant lancement : supprime définitivement les espaces et comptes de test, leurs clips et vidéos, tes clips de test admin, et remet à zéro les statistiques (pubs, partages, codes promo, historique de crédits, tickets). Le compte Démo est remis à neuf.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <Stat label="Espaces de test" value={d.workspaces} testid="cleanup-count-workspaces" />
        <Stat label="Comptes de test" value={d.users} testid="cleanup-count-users" />
        <Stat label="Vidéos" value={d.videos} testid="cleanup-count-videos" />
        <Stat label="Clips" value={d.clips} testid="cleanup-count-clips" />
        <Stat label="Statistiques" value={d.stats} testid="cleanup-count-stats" />
      </div>
      <div className="rounded-xl bg-[#22e3a1]/5 border border-[#22e3a1]/20 p-4" data-testid="cleanup-kept">
        <div className="text-sm text-[#22e3a1] flex items-center gap-2 mb-2"><ShieldCheck className="w-4 h-4" />Comptes conservés ({d.kept_accounts.length})</div>
        <div className="flex flex-wrap gap-2">{d.kept_accounts.map((e) => <span key={e} className="text-xs font-mono bg-black/30 rounded-full px-3 py-1 text-slate-300">{e}</span>)}</div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Tape SUPPRIMER pour confirmer" data-testid="cleanup-confirm-input"
          className="flex-1 bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-sm text-white outline-none focus:border-[#ff4d6d]/60" />
        <button onClick={run} disabled={busy || confirm !== "SUPPRIMER"} data-testid="cleanup-run-btn"
          className="rounded-xl px-6 py-3 text-sm font-semibold bg-[#ff4d6d] text-white disabled:opacity-40 flex items-center justify-center gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}Tout effacer
        </button>
      </div>
    </div>
  );
};
